import { motion } from "framer-motion";

// Minimal iOS-style phone frame wrapping an app screenshot.
export const PhoneFrame = ({ src, alt, className = "", float = false }) => {
  const floatAnim = float
    ? { animate: { y: [0, -14, 0] }, transition: { duration: 6, repeat: Infinity, ease: "easeInOut" } }
    : {};

  return (
    <motion.div
      {...floatAnim}
      className={`relative mx-auto w-[260px] sm:w-[300px] ${className}`}
      data-testid="phone-frame"
    >
      <div className="relative rounded-[2.8rem] border-[10px] border-gray-900 bg-gray-900 shadow-2xl shadow-emerald-900/20">
        <div className="absolute left-1/2 top-0 z-10 h-6 w-32 -translate-x-1/2 rounded-b-2xl bg-gray-900" />
        <div className="overflow-hidden rounded-[2rem] bg-[#faf4e0]">
          <img src={src} alt={alt} className="block w-full" loading="lazy" />
        </div>
      </div>
    </motion.div>
  );
};
